// extracted by mini-css-extract-plugin
module.exports = {"button":"SlidersButton_button__f_0a3","arrow":"SlidersButton_arrow__0q2nY"};